export const PREDEFINED_WORK_TOOLS = [
  {
    name: 'Google Drive',
    icon: 'google-drive.svg',
  },
  {
    name: 'LinkedIn',
    icon: 'linkedin.svg',
  },
  {
    name: 'Facebook',
    icon: 'facebook.svg',
  },
  {
    name: 'Instagram',
    icon: 'instagram.svg',
  },
  {
    name: 'Monday',
    icon: 'monday.svg',
  },
  {
    name: 'Slack',
    icon: 'slack.svg',
  },
  {
    name: 'Gmail',
    icon: 'gmail.svg',
  },
  {
    name: 'Outlook',
    icon: 'outlook.svg',
  },
  {
    name: 'Zoom',
    icon: 'zoom.svg',
  },
  {
    name: 'Meet',
    icon: 'meet.svg',
  },
  {
    name: 'Skype',
    icon: 'skype.svg',
  },
  {
    name: 'WhatsApp',
    icon: 'whatsapp.png',
  },
  {
    name: 'Calendar',
    icon: 'google-calendar.png',
  },
  {
    name: 'Calendly',
    icon: 'calendly.png',
  },
];
